export default __webpack_public_path__ + "static/media/basics.7bfbc65c.svg";